"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharingMode = exports.SharingLevel = void 0;
var SharingLevel;
(function (SharingLevel) {
    SharingLevel["Open"] = "Open";
    SharingLevel["Edit"] = "Edit";
})(SharingLevel = exports.SharingLevel || (exports.SharingLevel = {}));
var SharingMode;
(function (SharingMode) {
    SharingMode["Private"] = "Private";
    SharingMode["Authenticated"] = "Authenticated";
    SharingMode["Public"] = "Public";
})(SharingMode = exports.SharingMode || (exports.SharingMode = {}));
//# sourceMappingURL=RequestOptions.js.map